import { TOGGLE_MINIMAP } from 'redux/minimap/actions'
import { ZOOM, ZOOM_IN } from 'redux/appliedFilters/actions'
import { set } from 'immutadot'

const initialState = {
    isEnabled: null,
}

export const minimap = (state = initialState, {type}) => {
    switch (type)
    {
        case TOGGLE_MINIMAP:
            return set(state, 'isEnabled', ! state.isEnabled)

        case ZOOM:
        case ZOOM_IN:
            if(state.isEnabled === null)
            {
                return set(state, 'isEnabled', true)
            }

            return state

        default:
            return state
    }
}
